module.exports = __webpack_public_path__ + "img/TECNOLOGIA-VITARA-4.16233aed.jpg";